import React from 'react';
import { Button } from 'antd';

type SecondaryButton = {
  onClick?: () => void;
  className?: string;
  disabled?:boolean;
  type?:'submit'|'button'|'reset';
  children?: JSX.Element | string;
  title?:string;
};

const SecondaryButton = ({
  onClick,
  className,
  disabled,
  type = 'submit',
  children,
  title,
}: SecondaryButton): JSX.Element => (
  <Button onClick={onClick} disabled={disabled} htmlType={type} className={`ant-btn-secondary ${className || ''}`}>
    {title || children}
  </Button>
);

SecondaryButton.displayName = 'SecondaryButton';

export default SecondaryButton;
